import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-customer-param',
  templateUrl: './delete-customer-param.component.html',
  styleUrls: ['./delete-customer-param.component.css']
})
export class DeleteCustomerParamComponent implements OnInit {

  paramData:any = []
  deleteId: any = "";
  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getCustomerParams()
 
  }

 

  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  getCustomerParams(){
    this.generic_service.getCustomerParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteCustomerParam(){
    this.generic_service.deleteCustomerParam(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getCustomerParams();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

}